import React from "react";
import { WelcomePage } from "./Welcomepage";



export const Body = () => {
    return (
        <>
      <WelcomePage></WelcomePage>

        </>
    )
}


      